
export class TokenMetaDataResponseDto {
    rolesInPayloadHasChanged: boolean;
}
